import { SelectValueTags } from '../SelectValueTags'

import * as styles from './MultiSelect.module.css'

function MultiSelect({
  Element = 'div',
  Select,
  Tags = SelectValueTags,
  className = styles.MultiSelect,
  disabled,
  multi = true,
  style,
  tagsProps,
  value,
  ...restProps
}) {
  return (
    <Element className={className} style={style}>
      <Select {...restProps} disabled={disabled} multi={multi} value={value} />
      {Tags ? <Tags {...tagsProps} disabled={disabled} value={value} /> : null}
    </Element>
  )
}

export default MultiSelect
